const dataLayer = window.dataLayer = window.dataLayer || [];

export const getDataLayer = () => {
    return dataLayer;
};
